import React from "react";
import { useRegex } from "../../../../../hooks/useRegex";

const MemberTel = ({ telNo }) => {
  const { TelFormat } = useRegex();

  return (
    <div className="tel">
      <span className="label">고객연락처</span>
      <div>{TelFormat(telNo)}</div>
    </div>
  );
};

export default MemberTel;
